//removeIf(production)
import ExternalType from "../../enums/external-status";
import ClaroluzBill from "./claroluz-bill";
import ClaroluzOffer from "./claroluz-offer";
//endRemoveIf(production)

class ClaroluzData {
    public status: ExternalType;
    public bill: ClaroluzBill | null;
    public offers: ClaroluzOffer[];

    constructor(status: ExternalType, bill?: ClaroluzBill) {
        this.status = status;
        this.bill = bill ?? null;
        this.offers = [];
    }

    public addOffer(offer: ClaroluzOffer) {
        this.offers.push(offer);
    }
}

//removeIf(production)
export default ClaroluzData;
//endRemoveIf(production)